import { environment } from '@environments/environment';

export const GET_FEATURED_BLOG_ARTICLES_QUERY = (langcode: string, blogType: 'b2b' | 'b2c') => ({
  query: '_search',
  index: environment?.integrations?.fournierWebservice?.index_blog ?? '',
  body: {
    size: 3,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              type: blogType,
            },
          },
          {
            term: {
              promote: true,
            },
          },
        ],
      },
    },
    sort: [
      {
        created_timestamp: {
          order: 'desc',
        },
      },
    ],
    _source: ['url', 'created', 'image', 'name', 'title'],
  },
});
